import React from 'react';

import { twMerge } from 'tailwind-merge';

interface Props {
  id?: string;
  children?: React.ReactNode;
  onClick: (event: React.MouseEvent) => void;
  variant?: 'primary' | 'secondary' | 'danger';
  btn_size?: 'small' | 'big';
  className?: string;
  type?: 'button' | 'submit';
}

export default function InlineButton({
  id,
  children,
  onClick,
  variant = 'primary',
  btn_size = 'small',
  className,
  type,
}: Props) {
  const variantToClass = {
    primary: 'flex items-center  px-2.5  py-0 gap-1 bg-blue-500 text-white',
    danger: 'flex items-center  px-2.5  py-0 gap-1 bg-red-450 text-white ',
    secondary: 'flex items-center   px-2.5  py-0 gap-1 bg-white text-gray-700 ',
  };
  const variantToSize = {
    small: 'text-sm font-semibold',
    big: 'text-base font-semibold',
  };

  const variantToStyle = {
    primary: {},
    danger: {},
    secondary: {},
  };
  function handleClick(event) {
    event?.preventDefault();
    onClick(event);
  }

  return (
    <button
      id={id ?? 'button_id'}
      type={type}
      onClick={handleClick}
      className={twMerge(variantToClass[variant], variantToSize[btn_size], className)}
      style={variantToStyle[variant]}
    >
      {children}
    </button>
  );
}
